export const EDUCATIONAL_CONTENT_TYPE = {
  VIDEO: 'Video',
  ARTICLE: 'Article',
} as const;

export interface EducationalContent {
  footer_type: string;
  image_url: string;
  link: string;
  title: string;
  subtitle: string;
  description: string;
}

export type JourneyEducationalContent = EducationalContent[];

export interface VideoList {
  image_url: string;
  link: string;
  subtitle: string;
  video_id: string;
  video_title: string;
}

export interface EducationalVideos {
  playlist_title: string;
  video_list: VideoList[];
}

export type EducationalVideosResponse = EducationalVideos[];